<template>
  <div class="user_wrap">
    <BreadCrumb crumb="敏感词设置"></BreadCrumb>
    <div class="top_bar">
        <el-row>
          <el-col :span="8">
            <el-input placeholder="请输入搜索内容: 账号/手机号/状态" v-model="keyword" class="input-with-select" size="small">
              <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
            </el-input>
          </el-col>
          <el-col :span="8" :offset="8"><AddWord @fnSetKey="fnGetKey" class="pull-right"></AddWord></el-col>

        </el-row>
    </div>

    <SensitiveSetTable :words="aWordsList"  @fnResetTable="fnGetData"></SensitiveSetTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddWord from '@/components/widget/AddWord'
import SensitiveSetTable from '@/components/widget/SensitiveSetTable'
import cons from '@/components/constant'

export default {
  name: 'SensitiveSet',
  data () {
    return {
      keyword:'',
      page:1,
      pages:8,
      pagesize:10,
      aWordsList:[]
    }
  },
  components:{
    BreadCrumb,
    AddWord,
    SensitiveSetTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/sensitive_words', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aWordsList = dat.data.data.words;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetKey:function(dat){
       this.keyword = dat;
       this.fnGetData(1);
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
  width:95.2%;
  overflow:hidden;
  margin:10px auto 10px;
}
.batch_operation, .export_data {
  width: 80px;
  height: 32px;
  color: #fff;
  font: 12px/32px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.batch_operation:hover, .export_data:hover {
  background-color: rgb(252, 119, 121);
}


</style>



// WEBPACK FOOTER //
// src/components/pages/SensitiveSet.vue